import {CheckboxGroupSearchFilterBlock} from 'plugins/modules/filter/components/CheckboxGroupSearchFilterBlock';
import {BrowserFilters} from 'plugins/modules/filter/helpers/BrowserFilters';
import {IFilterFacet} from 'plugins/modules/filter/types';
import React, {FC, useCallback, useMemo} from 'react';
import {isBrowserContext} from 'core/helpers';
import {useFiltersGtag} from 'hooks/analytics/gtag/catalog/useFiltersGtag';
import {EventAction} from 'modules/google-analytics/constants';
import {useFiltersRouterPush} from '../../hooks/useFiltersRouterPush';

interface IProps {
    filterList: IFilterFacet[];
    searchPlaceholder?: string;
}

export const SearchGroupCheckboxController: FC<IProps> = ({filterList, searchPlaceholder}) => {
    const {pushRoute} = useFiltersRouterPush();

    const sendFiltersGtag = useFiltersGtag();

    const filterInstance = useMemo(() => (isBrowserContext() ? BrowserFilters.getInstance() : null), []);

    const handleApply = useCallback(
        (filter: IFilterFacet, variantCode: string) => {
            if (!filterInstance) {
                return;
            }

            sendFiltersGtag(
                `${filter.title} - ${filter.variants?.find((variant) => variant.code === variantCode)?.title}`,
            );

            const {pathName} = filterInstance.userAddOneFilterValue(filter, variantCode);
            pushRoute(pathName, undefined, {scroll: false, shallow: true});
        },
        [filterInstance, pushRoute, sendFiltersGtag],
    );

    const handleDiscard = useCallback(
        (filter: IFilterFacet, variantCode: string) => {
            if (!filterInstance) {
                return;
            }

            sendFiltersGtag(
                `${filter.title} - ${filter.variants?.find((variant) => variant.code === variantCode)?.title}`,
                EventAction.RemoveFilter,
            );

            const {pathName} = filterInstance.userRemoveOneFilterValue(filter, variantCode);
            pushRoute(pathName, undefined, {scroll: false, shallow: true});
        },
        [filterInstance, pushRoute, sendFiltersGtag],
    );

    return (
        <CheckboxGroupSearchFilterBlock
            filterList={filterList}
            onApply={handleApply}
            onDiscard={handleDiscard}
            searchPlaceholder={searchPlaceholder}
        />
    );
};
